var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#EC5C52",
    stroke: "#EC5C52",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 6.5C9.4055 6.5 6.5 9.4055 6.5 13C6.5 16.5945 9.4055 19.5 13 19.5C16.5945 19.5 19.5 16.5945 19.5 13C19.5 9.4055 16.5945 6.5 13 6.5ZM16.25 15.3335L15.3335 16.25L13 13.9165L10.6665 16.25L9.75 15.3335L12.0835 13L9.75 10.6665L10.6665 9.75L13 12.0835L15.3335 9.75L16.25 10.6665L13.9165 13L16.25 15.3335Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.ed4723e16dc6999c15262af1c5d942c2.svg";
export { ForwardRef as ReactComponent };